import { useState } from 'react';
import { Link } from 'react-router-dom';
import ClickOutside from '../ClickOutside';
import { useUserInfo } from '../../react-query/queries';
import Avatar from '../../school_panel/components/ui/Avatar';
import { FaChevronDown } from '../../school_panel/components/ui/icons';
import { FaSignOutAlt } from 'react-icons/fa';
import { Sparkles } from 'lucide-react';

const ROLE_LABELS: Record<string, string> = {
  superuser: 'Platform admin',
  school_admin: 'School admin',
  teacher: 'Teacher',
  counselor: 'Counselor',
  admin: 'Admin',
  school: 'School account',
  college_university: 'College / university',
  student: 'Student',
};

export function roleLabel(role?: string | null): string {
  if (!role) return '';
  return ROLE_LABELS[role] ?? role.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase());
}

const DropdownUser = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { data, isLoading } = useUserInfo();
  const name: string = data?.name || (isLoading ? '' : 'Account');
  const role = roleLabel(data?.role);
  const institution: string | undefined = data?.institution_name;

  return (
    <ClickOutside onClick={() => setDropdownOpen(false)} className="relative">
      <button
        type="button"
        onClick={() => setDropdownOpen(o => !o)}
        aria-haspopup="menu"
        aria-expanded={dropdownOpen}
        className="flex items-center gap-3 rounded-lg px-1 py-1 hover:bg-gray-2 dark:hover:bg-meta-4"
      >
        <span className="hidden text-right lg:block">
          <span className="block text-sm font-medium text-black dark:text-white">{name}</span>
          <span className="block text-xs text-bodydark2">{role}</span>
        </span>
        <Avatar name={name || '?'} size="md" />
        <FaChevronDown className={`hidden text-xs text-bodydark2 transition-transform sm:block ${dropdownOpen ? 'rotate-180' : ''}`} />
      </button>

      {dropdownOpen && (
        <div role="menu" className="absolute right-0 z-50 mt-3 w-64 rounded-xl border border-stroke bg-white shadow-card dark:border-strokedark dark:bg-boxdark">
          <div className="border-b border-stroke px-4 py-3 dark:border-strokedark">
            <p className="truncate text-sm font-semibold text-black dark:text-white">{name}</p>
            <p className="truncate text-xs text-bodydark2">{[role, institution].filter(Boolean).join(' · ')}</p>
          </div>
          <Link
            role="menuitem"
            to="/settings/ai"
            onClick={() => setDropdownOpen(false)}
            className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-black hover:bg-gray-2 dark:text-white dark:hover:bg-meta-4"
          >
            <Sparkles size={14} aria-hidden="true" />
            My AI credit
          </Link>
          <Link
            role="menuitem"
            to="/logout"
            className="flex items-center gap-3 rounded-b-xl px-4 py-3 text-sm font-medium text-danger hover:bg-danger/5"
          >
            <FaSignOutAlt />
            Sign out
          </Link>
        </div>
      )}
    </ClickOutside>
  );
};

export default DropdownUser;
